export default __webpack_public_path__ + "static/media/zipdoc.f0c31033.svg";